import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { CardSetTransformationService, CoreService, DataService, DialogResult, DialogService, FormConfigurationService, SaveDataRequest, SaveFormEvent, SpinnerService } from 'dspx-core';
import { finalize, take } from 'rxjs';
import { API_ENDPOINTS, API_ENDPOINT_KEYS } from '../../constants/api-endpoints.constants';
import { NAV_TAB_NUMBERS, PAGE_INDEX, PAGE_NUMBERS, POP_UP_CODES, QUESTION_CODES, REFERENCE_DATA_IDS, SAVE_RESULT_STATUS, SECTION_CODES, SECTION_INDEX, SERVER_ERROR_POP_UP_CODES } from '../../constants/app-data.constants';
import { ROUTE_CONSTANTS } from '../../constants/route.constants';
import { TEMPLATES, VERSIONS } from '../../constants/templates.constants';
import { GLStringLookupMappingSaveDataRequest } from '../../interfaces/gl-string-lookup-mapping-save-request.interface';
import { AppDataService } from '../../services/app-data.service';
import { ErrorService } from '../../services/error.service';
import { BaseCardSetDetailComponent } from '../base-card-set-detail-component/base-card-set-detail.component';

@Component({
  selector: 'app-exported-invoice',
  templateUrl: './exported-invoice.component.html',
  styleUrl: './exported-invoice.component.scss'
})
export class ExportedInvoiceComponent extends BaseCardSetDetailComponent implements OnInit {

  fieldTypeReplacements = CardSetTransformationService.cardSetWithFlatTabsFieldTypeReplacements;
  formServiceEndpoint: string = API_ENDPOINT_KEYS.getFormConfig;

  templateId: number = TEMPLATES.monitorInvoiceExport;
  versionNo: number = VERSIONS.latest;
  model: any;
  activeDialog: string = '';
  id: string = '';
  isEditing: boolean = false;
  private invoiceStatus: string;

  constructor(protected router: Router,
    protected route: ActivatedRoute,
    protected appDataService: AppDataService,
    protected dialogService: DialogService,
    private coreService: CoreService,
    private spinnerService: SpinnerService,
    private dataService: DataService,
    private errorService: ErrorService,
    private formConfigurationService: FormConfigurationService,
  ) {
    super(router, appDataService, dialogService);
  }

  ngOnInit(): void {
    this.coreService.applicationFunctions = {};
    this.coreService.conditionFunctions = {
      isEditing: () => this.isEditing
    };

    this.route.paramMap.subscribe((paramMap: ParamMap) => {
      const id = paramMap.get('id');
      if (id) {
        this.formServiceEndpoint = API_ENDPOINT_KEYS.getExportedInvoiceConfigAndResponse;
        this.id = id;
      }
    });

    this.coreService.applicationFunctions = {
      showResubmitButton: () => this.showResubmitButton()
    }
  }
  
  ngAfterViewInit(): void {
  }

  ngOnDestroy(): void {
    this.unsubscribeSubscriptions();
    this.coreService.applicationFunctions = {};
    this.coreService.repeatingPageFunctions = {};
    this.coreService.repeatingSectionFunctions = {};
  }

  formLoaded(event: any): void {
    this.invoiceStatus = event.invoiceStatus;
  }

  modelChanged(event: any): void {
  }

  filter(event: any): void {
  }

  buttonClicked(event: any): void {
  }

  cancel(event: any) {
    this.exit();
  }

  save(event: SaveFormEvent) {
    const saveDataRequest: SaveDataRequest = {
      template: this.templateId,
      versionNumber: this.versionNo,
      id: this.id,
      response: event.model,
      expectedLastUpdateTime: event.lastUpdatedTime,
      isSubmit: event.isSubmit
    }
    if (!event.isFormValid) {
      this.baseForm.markAllFieldsAsTouched();
      if (!this.baseForm.fields[0]?.formControl.valid) {
        this.baseForm.showValidationSummary(true);
        this.dialogService.showDialog(POP_UP_CODES.common.validationError);
      }
      else {
        this.saveData(saveDataRequest);
      }
    }
    else {
      this.saveData(saveDataRequest);
    }
  }

  private exit(ignoreUnsavedChanges = false): void {
    this.navigate(['/', ROUTE_CONSTANTS.exportedInvoice.list], ignoreUnsavedChanges);
  }

  private saveData(request: SaveDataRequest) {

    this.activeDialog = request.isSubmit ? POP_UP_CODES.exportedInvoice.resubmitConfirmation : POP_UP_CODES.exportedInvoice.saveConfirmation;
    this.dialogService.showConfirm(this.activeDialog).subscribe(data => {
      if (data === DialogResult.ACCEPTED) {
        this.spinnerService.showSpinner();
        this.registerSubscription(
          this.dataService.saveData(API_ENDPOINTS.exportedInvoice.save, request)
            .pipe(
              take(1),
              this.errorService.errorHandler(),
              finalize(() => this.spinnerService.hideSpinner())
            )
            .subscribe(data => {
              if (data?.status === SAVE_RESULT_STATUS.success) {
                if (SERVER_ERROR_POP_UP_CODES.saveReferenceData.includes(data.message)) {
                  this.activeDialog = data.message;
                  this.dialogService.showDialog(this.activeDialog);
                }
                else {
                  this.reloadPage();
                }
              }
            })
        );
      }
    });
  }

  private showResubmitButton() {
    return this.invoiceStatus == REFERENCE_DATA_IDS.invoiceStatus.rejected;
  }

}
